import "./GroupButtons.css";

const GroupButtons = ({buttons, setSelected, selected}) => {

    const getClasses = (index) => {

        let selectedClass = selected == index ? " groupButtonSelected": "";

        if(index == 0)
            selectedClass += ' groupButtonFirst';

        if(index + 1 == buttons.length)
            selectedClass += ' groupButtonLast';

        return 'groupButton' + selectedClass;
    };

    return (
    <div className="groupButtonsContainer">
        {
            buttons.map((button, index) => 
            <div key={`groupButton_${button.text}_${index}`} className={getClasses(index)} onClick={() => setSelected(index)}>
                {button.text}
            </div>)
        }
    </div>);
}

export default GroupButtons;